<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-group row">
    <label for="old_password" class="label col-sm-3 col-form-label">
      {{ "input.currentPassword.label" | translate }}
    </label>
    <div>
      <input
        type="text"
        nbInput
        fullWidth
        [ngClass]="{ isDisabled: !isEditing }"
        id="old_password"
        formControlName="old_password"
        [status]="showInputError('old_password') ? 'danger' : 'basic'"
      />
    </div>
  </div>
  <!--  -->
  <div class="form-group row">
    <label for="new_password" class="label col-sm-3 col-form-label">
      {{ "input.newPassword.label" | translate }}
    </label>
    <div>
      <input
        type="text"
        nbInput
        fullWidth
        [ngClass]="{ isDisabled: !isEditing }"
        id="new_password"
        formControlName="new_password"
        [status]="showInputError('new_password') ? 'danger' : 'basic'"
      />
      <span
        class="error-caption"
        *ngIf="
          form.get('new_password')?.touched &&
          form.get('new_password')?.errors?.['minlength']
        "
      >
        {{ "input.newPassword.tooShort" | translate }}
      </span>
    </div>
  </div>

  <div class="form-group row">
    <label for="confirm_new_password" class="label col-sm-3 col-form-label">
      {{ "input.repeatPassword.label" | translate }}
    </label>
    <div>
      <input
        type="text"
        nbInput
        fullWidth
        [ngClass]="{ isDisabled: !isEditing }"
        id="confirm_new_password"
        formControlName="confirm_new_password"
        [status]="showInputError('confirm_new_password') ? 'danger' : 'basic'"
      />
      <span
        class="error-caption"
        *ngIf="form.get('confirm_new_password')?.errors?.['notMatch']"
      >
        {{ "input.repeatPassword.notMatch" | translate }}
      </span>
      <span
        class="error-caption"
        *ngIf="
          form.get('confirm_new_password')?.touched &&
          form.get('confirm_new_password')?.errors?.['minlength']
        "
      >
        {{ "input.newPassword.tooShort" | translate }}
      </span>
    </div>
  </div>

  <div class="actions">
    <button
      *ngIf="isEditing"
      type="button"
      nbButton
      status="danger"
      outline
      (click)="cancelEdit()"
    >
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      *ngIf="isEditing"
      type="submit"
      nbButton
      status="primary"
      [nbSpinner]="saving"
      nbSpinnerStatus="control"
      [disabled]="saving"
    >
      {{ "buttons.save" | translate }}
    </button>

    <button
      *ngIf="!isEditing"
      type="button"
      nbButton
      outline
      status="primary"
      (click)="isEditing = true"
    >
      {{ "buttons.edit" | translate }}
    </button>
  </div>
</form>
